import { Edit, Index, List } from "../Components/index.js";

export default [
    {
        path: "/calendar",
        component: Index,
        name: "calendar",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/events",
        component: List,
        name: "event-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/event/:id/edit",
        component: Edit,
        name: "event-edit",
        meta: {
            requiresAuth: true,
        },
    },
];
